import React from "react";
import { useAccount } from 'wagmi';
import { useWeb3Modal , Web3Button } from '@web3modal/react';




export const Connect = function () {
    const { address, isConnected } = useAccount()
    const { open } = useWeb3Modal()
    

   return (
        <React.Fragment>

            <>
                {address && isConnected ? (
                   
                        <Web3Button/>
                    
                ) : (
                    <button type="button" className="theme-btn" onClick={() => open()}>
                            Connect Wallet
                    </button>
                )
                }

            </>

        </React.Fragment >
    );
};

export default Connect;